import React, { FC } from "react";
import { Text } from "@telia/teddy";
import { Alert } from "../../../../components";
import VerificationBlock from "./VerificationBlock/VerificationBlock";
import { VERIFICATION_TARGET, VerificationTarget } from "../../../../../../constants";
import { PhoneNumberFormatters } from "../../../../app/utils";
import { VERIFICATION_DELIVERY_METHOD } from "../../../consts";
import TEXT from "../../../text-consts";
import CheckoutHorizontalRule from "../../atoms/CheckoutHorizontalRule/CheckoutHorizontalRule";

interface LegalConsentRequiredProps {
    isLegalOwnerVerified: boolean;
    isReSwitch: boolean;
    isSendingSMSOrEmail: boolean;
    legalOwnerName: string;
    legalOwnerPhone: string;
    onCodeConfirm: (code: string, target: VerificationTarget) => void;
    onWithOrResendPinClick: (target: VerificationTarget, method: string) => void;
}

const LegalConsentRequired: FC<LegalConsentRequiredProps> = (props) => {
    const {
        isLegalOwnerVerified,
        isReSwitch,
        isSendingSMSOrEmail,
        legalOwnerName,
        legalOwnerPhone,
        onCodeConfirm,
        onWithOrResendPinClick,
    } = props;

    const verificationMethod = isReSwitch ? "LOGIN" : VERIFICATION_DELIVERY_METHOD.SMS;

    return (
        <div>
            {!isReSwitch && <CheckoutHorizontalRule />}
            <br />
            <VerificationBlock
                id="verification-block-legal-owner"
                verified={isLegalOwnerVerified}
                target={VERIFICATION_TARGET.FORMER_LEGAL_OWNER_CONSENT_TRANSFER_B2B}
                method={verificationMethod}
                onCodeSend={onWithOrResendPinClick}
                isSendingSMSOrEmail={isSendingSMSOrEmail}
                onCodeConfirm={onCodeConfirm}
            >
                {!isReSwitch && (
                    <Alert
                        title={TEXT.PERSONAL_DETAILS.VERIFICATION.LEGAL_OWNER_CONSENT.HEADING}
                        kind="neutral"
                        icon="alert"
                    >
                        {TEXT.PERSONAL_DETAILS.VERIFICATION.LEGAL_OWNER_CONSENT.DESCRIPTION}
                    </Alert>
                )}
                <Text mb="100" variant="additional-100" data-di-mask>
                    {TEXT.COMMON.OWNER}: <b>{legalOwnerName}</b>
                    <br />
                    {TEXT.COMMON.MOBILENUMBER}: <b>{PhoneNumberFormatters[0].displayFn(legalOwnerPhone || "")}</b>
                    <br />
                </Text>
            </VerificationBlock>
        </div>
    );
};

export default LegalConsentRequired;
